import React, { FunctionComponent } from 'react';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import { isMobile } from 'helpers/device_helper';
import { KeepModalType } from 'features/prop/store/plans/interfaces';
import { StyleOption } from 'features/prop/scenes/MyChallenges/components/KeeperAlertModal/KeeperAlertModal';

type useStylesProps = {
    paperWidth?: string | number;
    keeperState?: 'alert' | 'purchase';
};

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        modal: {
            display: 'flex',
            alignItems: (props: useStylesProps) => (props.keeperState === 'alert' ? 'center' : 'flex-start'),
            marginTop: (props: useStylesProps) => (props.keeperState === 'alert' ? '0%' : isMobile() ? '25%' : '10%'),
            justifyContent: 'center',
        },
        paper: {
            width: (props: useStylesProps) => props.paperWidth || 700,
            backgroundColor: theme.palette.background.paper,
            borderRadius: 12,
            boxShadow: (props: useStylesProps) =>
                props.keeperState === 'purchase'
                    ? `0px 4px 32px 0px rgba(16, 24, 40, 0.10);`
                    : '0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)',
            outline: '0 !important',
        },
        backdrop: {
            backdropFilter: 'blur(8px)',
        },
    })
);

export type TransitionsModalProps = {
    children: React.ReactNode;
    open: boolean;
    handleClose: () => void;
    BackdropProps?: any;
    paperWidth?: string | number;
    keeperState?: 'alert' | 'purchase';
};

const ControlledModal: FunctionComponent<TransitionsModalProps> = ({
    children,
    open,
    handleClose,
    BackdropProps,
    paperWidth,
    keeperState,
}) => {
    const classes = useStyles({ paperWidth, keeperState });

    return (
        <Modal
            aria-labelledby="transition-modal"
            aria-describedby="transition-modal"
            className={classes.modal}
            open={open}
            onClose={handleClose}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
                timeout: 500,
                className: classes.backdrop,
                ...BackdropProps,
            }}
        >
            <Fade in={open}>
                <div className={classes.paper}>{children}</div>
            </Fade>
        </Modal>
    );
};

export default ControlledModal;
